import * as Feather from "feather-icons";
import getCookie from "../utils/cookie";


export default class Notifications {
    constructor(element) {
        this.sourceUrl = element.getAttribute("data-source-url");
        this.notificationsDiv = element.querySelector("#notifications");
        this.unreadMarker = element.querySelector("#notificationDropdown");

        this.headers = {
            "X-CSRFToken": getCookie("csrftoken"),
            "Content-Type": "application/json"
        };

        this.loadNotifications();
        this._addEventListeners();
    }

    loadNotifications() {
        // Load the data
        fetch(this.sourceUrl)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.length > 0){this.notificationsDiv.innerHTML = "";}
                let unread = 0;
                data.forEach((notification) => {
                    this.addNotification(notification.html);
                    if (notification.read !== true) {
                        unread += 1;
                    }
                });
                // Need to do this because notifications might contain icons
                Feather.replace();

                if (unread > 0) {
                    // Toggle unread marker
                    this.showUnreadMarker();
                } else {
                    this.hideUnreadMarker();
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    addNotification(notificationHtml) {
        let newNotification = document.createElement("div");
        newNotification.innerHTML = notificationHtml;
        this.notificationsDiv.appendChild(newNotification);
        let actionElement = newNotification.querySelector(".notification-action");
        actionElement.addEventListener("click", (event) => {
            this._followActionUrl(
              event.currentTarget
            );
        });
    }

    showUnreadMarker() {
       this.unreadMarker.classList.add("unread");
    }

    hideUnreadMarker() {
       this.unreadMarker.classList.remove("unread");
    }

    _markAsRead(notifictionElement, endpoint) {
        fetch(endpoint, {
            method: "PUT",
            headers: this.headers
        })
          .then((response) => {
              return response.json();
          })
          .then((notification) => {
              // Remove unread class from element
              if(notification.read) {
                notifictionElement.classList.remove("unread");
              }
          })
          .catch((error) => {
              console.log(error);
          });
    }

    _followActionUrl(actionElement) {
        const markAsReadUrl = actionElement.getAttribute("data-source-url");
        const actionUrl = actionElement.getAttribute("href");
        let notificationElement = actionElement.querySelector(".notification");
        this._markAsRead(notificationElement, markAsReadUrl);
    }

    _addEventListeners() {
        let bellElement = document.querySelector(".notification-bell");
        bellElement.addEventListener("click", (event) => {
            this.hideUnreadMarker();
        });
    }
}